import React from 'react';
import { Calendar, ChevronRight, ChevronDown } from 'lucide-react';

const brl = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);
const fmtDate = (d) => { if (!d) return '---'; return new Date(d + 'T00:00:00').toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' }); };

const STATUS_CFG = {
  PENDENTE:   { cls: 'bg-amber-100 text-amber-800 border-amber-300',       label: 'Pendente' },
  IMPLANTADO: { cls: 'bg-blue-100 text-blue-800 border-blue-300',          label: 'Implantado' },
  NF_EMITIDA: { cls: 'bg-emerald-100 text-emerald-800 border-emerald-300', label: 'NF Emitida' },
  ATRASADO:   { cls: 'bg-red-100 text-red-700 border-red-300',             label: 'Atrasado' },
  CANCELADO:  { cls: 'bg-slate-100 text-slate-500 border-slate-300',       label: 'Cancelado' },
};

const DIAS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

const DashboardPedidosSemana = ({ pedidosSemanaFiltrados, semana, diasAbertos, onToggleDia, clientes, onNavigate }) => {
  const clienteIdMap = Object.fromEntries(clientes.map(c => [c.id, c]));
  const nomeCliente = (p) => clienteIdMap[p.cliente_id]?.nome_fantasia || p.cliente_nome || '---';

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden mb-5">
      {/* Header */}
      <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 bg-[#EFF6FF] rounded-lg flex items-center justify-center">
            <Calendar size={16} className="text-[#0A3D73]" />
          </div>
          <div>
            <p className="text-sm font-black text-slate-800">Painel da Semana</p>
            <p className="text-xs text-slate-400">{fmtDate(semana.inicio)} a {fmtDate(semana.fim)} · Entregas previstas</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="text-right">
            <p className="text-xs text-slate-400 font-bold">{pedidosSemanaFiltrados.length} pedidos</p>
          </div>
          <button onClick={() => onNavigate('/pedidos')}
            className="flex items-center gap-1 text-xs font-black text-[#0A3D73] border border-[#0A3D73]/30 px-3 py-1.5 rounded-lg hover:bg-[#0A3D73] hover:text-white transition-colors">
            Ver todos <ChevronRight size={12} />
          </button>
        </div>
      </div>

      {/* Dias em acordeão */}
      <div className="divide-y divide-slate-100">
        {Array.from({ length: 7 }).map((_, i) => {
          const d = new Date(semana.inicio + 'T00:00:00');
          d.setDate(d.getDate() + i);
          const dStr = d.toISOString().split('T')[0];
          const isHoje = dStr === semana.hoje;
          const pedidosDia = pedidosSemanaFiltrados.filter(p => p.data_entrega?.substring(0, 10) === dStr);
          const aberto = diasAbertos[dStr];

          return (
            <div key={dStr}>
              <button
                onClick={() => pedidosDia.length > 0 && onToggleDia(dStr)}
                className={`w-full flex items-center justify-between px-5 py-3 transition-colors text-left
                  ${isHoje ? 'bg-blue-50' : 'bg-white hover:bg-slate-50'}
                  ${pedidosDia.length === 0 ? 'cursor-default opacity-50' : 'cursor-pointer'}
                `}>
                <div className="flex items-center gap-3">
                  <div className="w-8 text-center flex-shrink-0">
                    <p className={`text-xs font-black uppercase ${isHoje ? 'text-[#0A3D73]' : 'text-slate-400'}`}>{DIAS[d.getDay()]}</p>
                    <p className={`text-sm font-black ${isHoje ? 'text-[#0A3D73]' : 'text-slate-600'}`}>{String(d.getDate()).padStart(2, '0')}</p>
                  </div>
                  {isHoje && <span className="text-xs font-black text-[#0A3D73] bg-blue-100 px-2 py-0.5 rounded-full">Hoje</span>}
                  {pedidosDia.length === 0 && <span className="text-xs text-slate-400">Sem entregas</span>}
                </div>
                <div className="flex items-center gap-3">
                  {pedidosDia.length > 0 && (
                    <>
                      <span className="text-xs font-black text-white bg-[#0A3D73] w-6 h-6 rounded-full flex items-center justify-center">{pedidosDia.length}</span>
                      <div className="hidden md:flex gap-1">
                        {Object.entries(pedidosDia.reduce((a, p) => { const s = p.status; a[s] = (a[s] || 0) + 1; return a; }, {})).map(([s, q]) => (
                          <span key={s} className={`text-[9px] font-black px-1.5 py-0.5 rounded border ${STATUS_CFG[s]?.cls || ''}`}>{q} {s}</span>
                        ))}
                      </div>
                      <ChevronDown size={14} className={`text-slate-400 transition-transform ${aberto ? 'rotate-180' : ''}`} />
                    </>
                  )}
                </div>
              </button>

              {aberto && pedidosDia.length > 0 && (
                <div className="bg-slate-50 border-t border-slate-100">
                  {pedidosDia.map((p, idx) => {
                    const cfg = STATUS_CFG[p.status] || STATUS_CFG.PENDENTE;
                    return (
                      <div key={p.id || idx}
                        onClick={() => onNavigate('/pedidos')}
                        className="flex items-center gap-3 px-5 py-2.5 hover:bg-white cursor-pointer transition-colors border-b border-slate-100 last:border-0 text-xs">
                        <div className="w-16 flex-shrink-0">
                          <p className="text-slate-400 font-bold text-[10px] uppercase">FE</p>
                          <p className="font-black text-[#0A3D73] font-mono truncate">{p.numero_fe || '---'}</p>
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-slate-400 font-bold text-[10px] uppercase">Produto</p>
                          <p className="font-bold text-slate-700 truncate">{p.item_nome || '---'}</p>
                        </div>
                        <div className="w-28 flex-shrink-0 hidden sm:block">
                          <p className="text-slate-400 font-bold text-[10px] uppercase">Cliente</p>
                          <p className="font-black text-slate-800 truncate">{nomeCliente(p).split(' ')[0]}</p>
                        </div>
                        <div className="w-20 flex-shrink-0 hidden md:block">
                          <p className="text-slate-400 font-bold text-[10px] uppercase">Valor</p>
                          <p className="font-black text-slate-700">{brl(p.valor_total)}</p>
                        </div>
                        <span className={`flex-shrink-0 px-2 py-0.5 text-[9px] font-black border rounded-full ${cfg.cls}`}>{cfg.label}</span>
                        <ChevronRight size={12} className="text-slate-300 flex-shrink-0" />
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DashboardPedidosSemana;
